module.exports = __webpack_public_path__ + "assets/media/instagram-footer.7d0abb06.svg";